import _ from 'lodash'
import template from './departments-edit.html'
export default {
	controller,
	controllerAs: 'vm',
	template,
}

/* @ngInject */
function controller($mdDialog, $log, Project, Department, User, department) {
	var vm = this
	vm.$onInit = () => {
		//API methods
		vm.cancel = cancel
		vm.update = update

		//Scope attributes
		vm.title = department.name
		vm.department = department.cloneFields()

		activate()
		function activate() {}

		function cancel() {
			close()
		}

		function close() {
			$mdDialog.cancel()
		}

		function update() {
			department.DSUpdate(vm.department).then(
				function (department) {
					close()
				},
				function (err) {
					$log.warn(err)
				},
			)
		}
	}
}
